<template>

  <b-overlay
    :show="showOverlay"
    rounded="sm"
  >

    <collectives-list-add-new
      :is-add-new-collectives-sidebar-active.sync="isAddNewCollectivesSidebarActive"
      :organisation-options="organisationOptions"
      @refetch-data="refetchCollectivesData"
    />

    <template>

      <b-row>

        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >

          <template>

            <!-- Table Container Card -->
            <b-card
              no-body
            >

              <div class="m-2">
                <!-- Table Top -->
                <b-row>
                  <!-- Per Page -->
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <label>Entries</label>
                    <v-select
                      v-model="perPage"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false"
                      class="per-page-selector d-inline-block ml-50 mr-1"
                    />
                  </b-col>
                  <!-- Add -->
                  <b-col
                    class="d-flex align-items-center justify-content-end"
                    cols="12"
                    md="6"
                  >
                    <b-button
                      v-if="$can('create', 'product')"
                      variant="primary"
                      @click="isAddNewCollectivesSidebarActive = true"
                    >
                      Toevoegen
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-table
                ref="refCollectivesListTable"
                :items="fetchCollectives"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                show-empty
                empty-text="Geen overeenkomende records gevonden"
                class="position-relative categorie-table"
              >

                <!-- Column: Id -->
                <template #cell(id)="data">
                  <b-link
                    :to="{ name: 'app-collectives-edit', params: { id: data.item.id }}"
                    class="font-weight-bold"
                  >
                    #{{ data.value }}
                  </b-link>
                </template>

                <template #cell(companyID)="data">
                  <div class="text-nowrap">
                    <span class="align-text-top text-capitalize">{{ resolveOrganisationName(data.item.companyID) }}</span>
                  </div>
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">

                  <div class="text-nowrap">
                    <b-link
                      :id="`collective-view-action-row-${data.item.id}`"
                      :to="{ name: 'app-collectives-edit', params: { id: data.item.id }}"
                    >
                      <feather-icon
                        :id="`collective-row-${data.item.id}-preview-icon`"
                        class="cursor-pointer mx-1"
                        icon="EyeIcon"
                        size="16"
                      />
                    </b-link>
                    <b-tooltip
                      :target="`collective-view-action-row-${data.item.id}`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Aanpassen
                      </p>
                    </b-tooltip>
                    <feather-icon
                      :id="`collective-row-${data.item.id}-delete-icon`"
                      class="cursor-pointer"
                      size="16"
                      icon="TrashIcon"
                      @click="confirmCollectiveDeleteText(data.item.id)"
                    />
                    <b-tooltip
                      :target="`collective-row-${data.item.id}-delete-icon`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Verwijderen
                      </p>
                    </b-tooltip>
                  </div>
                </template>

              </b-table>
            </b-card>

          </template>

        </b-col>

      </b-row>

    </template>

  </b-overlay>

</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BLink, BTooltip, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import useCollectivesList from '@/views/pages/collectives/useCollectivesList'
import collectivesStoreModule from '@/views/pages/collectives/collectivesStoreModule'
import CollectivesListAddNew from '@/views/pages/collectives/collectives-add/CollectivesListAddNew.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import errorDefaultMessage from '@core/app-config/errorAndSuccesDefaultMessage'

export default {
  components: {
    CollectivesListAddNew,
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BLink,
    vSelect,
    BTooltip,
    BOverlay,
  },
  data() {
    return {
      organisationOptions: [],
    }
  },
  beforeMount() {
    this.getOrganisations()
  },
  methods: {
    resolveOrganisationName(id) {
      if (this.organisationOptions.find(org => org.id === id)) {
        return this.organisationOptions.find(org => org.id === id).name
      }

      return ''
    },
    getOrganisations() {
      store
        .dispatch('app-collectives-list/fetchOrganisations', {
          sortBy: 'name',
          sortDesc: false,
        })
        .then(response => {
          this.organisationOptions = response.data.items
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Ophalen organisaties',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: `${errorDefaultMessage.fetchDataError}`,
            },
          })
        })
    },
    confirmCollectiveDeleteText(id) {
      this.$swal({
        title: 'Weet je het zeker?',
        text: 'U kunt dit niet meer terugdraaien!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder het!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          store.dispatch('app-collectives-list/deleteCollective', { id })
            .then(() => {
              this.refetchCollectivesData()
              this.$swal({
                icon: 'success',
                title: 'Verwijderd!',
                text: 'De collectief is verwijderd.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
  },
  setup() {
    const COLLECTIVES_APP_STORE_MODULE_NAME = 'app-collectives-list'

    // Register module
    if (!store.hasModule(COLLECTIVES_APP_STORE_MODULE_NAME)) store.registerModule(COLLECTIVES_APP_STORE_MODULE_NAME, collectivesStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COLLECTIVES_APP_STORE_MODULE_NAME)) store.unregisterModule(COLLECTIVES_APP_STORE_MODULE_NAME)
    })

    const isAddNewCollectivesSidebarActive = ref(false)

    const {
      fetchCollectives,
      tableColumns,
      perPage,
      currentPage,
      totalCollectives,
      dataMeta,
      perPageOptions,
      isSortDirDesc,
      sortBy,
      refCollectivesListTable,
      refetchCollectivesData,
      showOverlay,
    } = useCollectivesList()

    return {
      isAddNewCollectivesSidebarActive,
      fetchCollectives,
      tableColumns,
      perPage,
      currentPage,
      totalCollectives,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refCollectivesListTable,
      refetchCollectivesData,
      showOverlay,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }

  .categorie-table{
    .description{
      width:30%;
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
